/* eslint-disable */
/* eslint-disable operator-linebreak */
/* eslint-disable consistent-return */
/* eslint-disable implicit-arrow-linebreak */
import moment from 'moment';
import { useEffect } from 'react';

export const randomStrForId = () =>
  `id-${Math.random().toString().substr(2, 5)}`;

export const dateDifference = (inputData) =>
  moment(new Date(inputData)).fromNow();

export const isRequired = (value) => {
  if (value === '' || value === undefined || value === null) {
    // return { isRequired: true, message: `${name} is required ` };
    return true;
  }
};
// Number formating
export const formatNum = (num,) =>
  Number(Number(num)?.toFixed(2))?.toLocaleString("en-US");


export function validateEmail(email) {
  const emailRegx = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,16})+$/);
  return emailRegx.test(email) !== false;
}

export function isCheckLength(value, length) {
  if (value.length !== length) {
    return true;
  }
}

export function isCheckOnlyNumber(value) {
  const numberRegx = new RegExp(/^[0-9\b]+$/);
  return numberRegx.test(value) !== false;
}

export function isPassword(value) {
  let str = value;
  if (
    str.match(/[a-z]/g) &&
    str.match(/[A-Z]/g) &&
    str.match(/[0-9]/g) &&
    str.match(/[^a-zA-Z\d]/g) &&
    str.length >= 8
  ) {
    return true;
  }
  return false;
}

export function calculateAge(birthday) {
  // birthday is a date
  let ageDifMs = Date.now() - new Date(birthday).getTime();
  let ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const isAuthenticated = () => {
  const permissions = localStorage.getItem('userToken');
  if (permissions) {
    return true;
  }
  return false;
};

export function logout() {
  localStorage.clear();
  sessionStorage.clear();
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      const authChannel = new BroadcastChannel('auth');
      authChannel.postMessage({ type: 'LOGOUT' });
      authChannel.close();
    }
  } catch (e) {
    console.error('BroadcastChannel logout notification failed:', e);
  }
  window.location.href = '/login';
}

export const tokenExpire = (errorData, history) => {
  let status;
  if (errorData === undefined) {
    status = 666;
  } else {
    status = errorData;
  }

  switch (status) {
    // case 401:
    case 401:
      logout();
      history.push('/login');
      break;
    case 666:
      logout();
      history.push('/login');
      break;
    case 403:
      logout();
      history.push('/login');
      break;
    default:
      // Optionally handle other errors without forcing logout
      console.log(status);
      break;
  }
};

export const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', handleClick);

    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  });
};

export const isValidFile = (product, regulationCode, file, clientDetails) => {
  switch (product) {
    case 'P001':
      if (regulationCode === 'R001') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_ESMA_Accuracy_MIFIDII_TxnR_`,
            0,
          ) &&
          (file.type === 'text/xml' || file.type === 'text/csv')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Accuracy_MIFIDII_TxnR_`,
            0,
          ) &&
          (file.type === 'text/xml' || file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R002') {
        if (
          file.name.startsWith(
            `APA_${clientDetails.clientName}_FCA_Accuracy_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Accuracy_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R003') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Accuracy_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R004') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Accuracy_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R005') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Accuracy_MIFIDII_TxnR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R006') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_Accuracy_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }

      if (regulationCode === 'R007') { // EU EMIR REFIT
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Accuracy_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Accuracy_EMIR_REFIT_MarG_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Accuracy_EMIR_REFIT_Margins_`,
            0,
          ) &&
          (file.type === 'text/xml' || file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R008') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Accuracy_MIFIDII_RK_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R010') { // UK EMIR REFIT
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Accuracy_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_Accuracy_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
      }
      if (regulationCode === 'R011') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_Accuracy_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R013') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ASIC_Accuracy_ASIC_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R015') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_CFTC_Accuracy_CFTC_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R018') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_MAS_Accuracy_MAS_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R027') {
        if (
          file.name.startsWith(
            `APA_${clientDetails.clientName}_ESMA_Accuracy_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_ESMA_Accuracy_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R028') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_SEC_Accuracy_SEC_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      break;
    case 'P002':
      if (regulationCode === 'R001') {
        if (
          (file.name.startsWith(
            `NCA_${clientDetails.clientName}_ESMA_Middleware_MIFIDII_TxnR_`,
            0,
          ) &&
            file.type === 'text/xml') ||
          (file.name.startsWith(
            `NCA_${clientDetails.clientName}_ESMA_Middleware_MIFIDII_TxnR_`,
            0,
          ) &&
            file.type === 'text/csv') ||
          (file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Middleware_MIFIDII_TxnR_`,
            0,
          ) &&
            ((file.type === 'text/xml') || (file.type === 'text/csv')))
        ) {
          return true;
        }
        return false;
      }

      if (regulationCode === 'R002') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Middleware_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R003') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Middleware_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `MIFIDCASHCUST_${clientDetails.clientName}_ESMA_Middleware_EMIR_TrdR_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `DailyTrD_${clientDetails.clientName}_ESMA_Middleware_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R004') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Middleware_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R005') {
        if (
          (file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Middleware_MIFIDII_TxnR_`,
            0,
          ) &&
            file.type === 'text/xml') ||
          (file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Middleware_MIFIDII_TxnR_`,
            0,
          ) &&
            ((file.type === 'text/xml') || (file.type === 'text/csv')))
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R007') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Middleware_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          // (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv')
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv' || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `DailyTrD_${clientDetails.clientName}_ESMA_Middleware_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `MIFIDCASHCUST_${clientDetails.clientName}_ESMA_Middleware_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R010') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Middleware_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          // (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv')
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv' || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `MIFIDCASHCUST_${clientDetails.clientName}_FCA_Middleware_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') || file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R011') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Middleware_SFTR_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R012') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_JFSA_Middleware_JFSADER_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R013') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ASIC_Middleware_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ASIC_Middleware_ASIC_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R014') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FINRA_Middleware_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R015') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_CFTC_Middleware_CFTC_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R018') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_MAS_Middleware_MAS_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R019') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_CSA_Middleware_CSA_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R021') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Middleware_RTS2_TrdR_PTTR_`,
            0,
          ) &&
          (file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R028') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_SEC_Middleware_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_SEC_Middleware_SEC_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
        return false;
      }
      break;
    case 'P003':
      if (regulationCode === 'R001') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_ESMA_Completeness_MIFIDII_TxnR_`,
            0,
          ) &&
          file.type === 'text/xml'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Completeness_MIFIDII_TxnR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(`TRIGGER_${clientDetails.clientName}_SEED_`, 0)
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R002') {
        if (
          file.name.startsWith(
            `APA_${clientDetails.clientName}_FCA_Completeness_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Completeness_MIFIDII_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(`TRIGGER_${clientDetails.clientName}_SEED_`, 0)
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R003') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Completeness_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_TR_Completeness_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(`TRIGGER_${clientDetails.clientName}_SEED_`, 0)
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R004') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Completeness_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Completeness_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(`TRIGGER_${clientDetails.clientName}_SEED_`, 0)
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R005') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Completeness_MIFIDII_TxnR_`,
            0,
          ) &&
          file.type === 'text/xml'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Completeness_MIFIDII_TxnR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(`TRIGGER_${clientDetails.clientName}_SEED_`, 0)
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R007') {
        if (
          file.name.startsWith(
            `REGISTER_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TRIGGER_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.seed')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `REC_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `DAILY_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `STATESTREET_${clientDetails.clientName}_ESMA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R008') {
        if (
          file.name.startsWith(
            `REC_${clientDetails.clientName}_FCA_Completeness_MIFIDII_RK_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') ||
            file.type === 'text/csv')
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_Completeness_MIFIDII_RK_`,
            0,
          ) &&
          (file.name.toLowerCase().endsWith('.xlsx') ||
            file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R010') {
        if (
          file.name.startsWith(
            `REGISTER_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TRIGGER_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.seed')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `REC_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `DAILY_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `STATESTREET_${clientDetails.clientName}_FCA_Completeness_EMIR_REFIT_TrdR_`,
            0,
          ) &&
          ((file.type === 'text/csv') || (file.name.toLowerCase().endsWith('.xlsx')) || (file.type === 'text/xml'))
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R011') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_Completeness_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_FCA_Completeness_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(`TRIGGER_${clientDetails.clientName}_FCA_Completeness_SFTR_TrdR_`, 0)
          && file.name.toLowerCase().endsWith('.seed')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R015') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_CFTC_Completeness_CFTC_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_CFTC_Completeness_CFTC_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TRIGGER_${clientDetails.clientName}_CFTC_Completeness_CFTC_TrdR_`,
            0,
          )
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R019') {
        if (
          file.name.startsWith(
            `FIRM_${clientDetails.clientName}_CSA_Completeness_CSA_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        // console.log('file Name :', file);
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_CSA_Completeness_CSA_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        if (
          file.name.startsWith(
            `TRIGGER_${clientDetails.clientName}_CSA_Completeness_CSA_TrdR_`,
            0,
          )
        ) {
          return true;
        }
        return false;
      }
      break;
    case 'P004':
      if (regulationCode === 'R001') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_ESMA_BackReporting_MIFIDII_TxnR_`,
            0,
          ) &&
          (file.type === 'text/xml' || file.type === 'text/csv')
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R002') {
        return false;
      }
      if (regulationCode === 'R003') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_BackReporting_EMIR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R004') {
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_BackReporting_SFTR_TrdR_`,
            0,
          ) &&
          file.type === 'text/csv'
        ) {
          return true;
        }
        return false;
      }
      if (regulationCode === 'R005') {
        if (
          file.name.startsWith(
            `NCA_${clientDetails.clientName}_FCA_BackReporting_MIFIDII_TxnR_`,
            0,
          ) &&
          file.type === 'text/xml'
        ) {
          return true;
        }
        return false;
      }
      break;
    case 'P006':
      if (regulationCode === 'R007') {
        // if (
        //   file.name.startsWith(
        //     `FIRM_${clientDetails.clientName}_ESMA_EnO_REFIT_TrdR_`,
        //     0,
        //   ) &&
        //   (file.type === 'text/csv' || file.type === 'text/xml')
        // ) {
        //   return true;
        // }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_ESMA_EnO_REFIT_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
      }
      if (regulationCode === 'R010') {
        // if (
        //   file.name.startsWith(
        //     `FIRM_${clientDetails.clientName}_FCA_EnO_REFIT_TrdR_`,
        //     0,
        //   ) &&
        //   (file.type === 'text/csv' || file.type === 'text/xml')
        // ) {
        //   return true;
        // }
        if (
          file.name.startsWith(
            `TR_${clientDetails.clientName}_FCA_EnO_REFIT_TrdR_`,
            0,
          ) &&
          (file.type === 'text/csv' || file.type === 'text/xml')
        ) {
          return true;
        }
      }
      break;
    case 'file-storage':
      if (regulationCode === 'R001') {
        if ((file[0].name.toLowerCase().endsWith('.csv')) || (file[0].name.toLowerCase().endsWith('.xml')) || (file[0].name.toLowerCase().endsWith('.zip')) || (file[0].name.toLowerCase().endsWith('.xlsx')) || (file[0].name.toLowerCase().endsWith('.gz')) || (file[0].name.toLowerCase().endsWith('.txt')) || (file[0].name.toLowerCase().endsWith('.pptx')) || (file[0].name.toLowerCase().endsWith('.docx'))) {
          return true;
        }
      }
      break;
    case 'file-storage-demo':
      if (regulationCode === 'R001') {
        if ((file.name.toLowerCase().endsWith('.csv')) || (file.name.toLowerCase().endsWith('.xml')) || (file.name.toLowerCase().endsWith('.zip')) || (file.name.toLowerCase().endsWith('.xlsx')) || (file.name.toLowerCase().endsWith('.gz')) || (file.name.toLowerCase().endsWith('.txt')) || (file.name.toLowerCase().endsWith('.pptx')) || (file.name.toLowerCase().endsWith('.docx'))) {
          return true;
        }
      }
      break;
    // file storage
    case 'P007':
      if ((file.name.toLowerCase().endsWith('.csv')) || (file.name.toLowerCase().endsWith('.xml')) || (file.name.toLowerCase().endsWith('.zip')) || (file.name.toLowerCase().endsWith('.xlsx')) || (file.name.toLowerCase().endsWith('.xls')) || (file.name.toLowerCase().endsWith('.gz')) || (file.name.toLowerCase().endsWith('.txt')) || (file.name.toLowerCase().endsWith('.pptx')) || (file.name.toLowerCase().endsWith('.docx'))) {
        return true;
      }
      return false;
    // reference data
    case 'P008':
      if ((file.name.toLowerCase().endsWith('.csv')) || (file.name.toLowerCase().endsWith('.xlsx')) || (file.name.toLowerCase().endsWith('.xml'))) {
        return true;
      }
      return false;
    default:
      return false;
  }
};

// normalize text to remove unwanted spaces
export const normalizeText = (text = '') =>
  text?.toLowerCase()
    ?.replace(/\s+/g, ' ') // convert multiple spaces to single
    ?.trim();


export const createCSVFromRows = (rows) => {
  //  object to array
  const normalizedRows = Array.isArray(rows) ? rows : [rows];

  if (normalizedRows.length === 0) return '';

  const headers = Object.keys(normalizedRows[0]).join(',');

  const body = normalizedRows
    .map(row =>
      Object.values(row)
        .map(value => `"${String(value ?? '')}"`)
        .join(',')
    )
    .join('\n');

  return `${headers}\n${body}`;
};

export const getDerivedFileName = (selectedRows, statusCol = "Reg-X Status") => {
  try {
    const raw = selectedRows?.['File Name'];
    if (!raw) return null;

    // timestamp parts
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const dateStr = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}`;
    const timeStr = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

    // 1) remove "original_" / "orignal_" anywhere (case-insensitive)
    const cleaned = raw.replace(/(original_|orignal_)/gi, "");

    // 2) split name and extension (preserve original extension if present; default .csv)
    const dotIdx = cleaned.lastIndexOf(".");
    const ext = dotIdx !== -1 ? cleaned.slice(dotIdx) : ".csv";
    let stem = dotIdx !== -1 ? cleaned.slice(0, dotIdx) : cleaned;

    //remove everything from the last _YYYYMMDD to the end
    stem = stem.replace(/_\d{8}.*$/i, "");


    // 4) build final name with new timestamp before extension
    let finalName = ''
    if (selectedRows?.statusCol === 'RSND') {
      finalName = `${stem}_${dateStr}_RSND${timeStr}${ext}`;
    } else {
      finalName = `${stem}_${dateStr}_HOLD${timeStr}${ext}`;
    }
    return finalName;
  } catch (err) {
    console.log(err);
    return null;
  }
};
